import { render, staticRenderFns } from "./uploadingBox.vue?vue&type=template&id=03c93db2&scoped=true&"
import script from "./uploadingBox.vue?vue&type=script&lang=js&"
export * from "./uploadingBox.vue?vue&type=script&lang=js&"
import style0 from "./uploadingBox.vue?vue&type=style&index=0&id=03c93db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c93db2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
